import React from "react";

import { BorderedBlock } from "../../../../../../features/common-attributes/components/bordered-block/bordered-block.component";
import { CheckboxField } from "../../../../../../features/forms/fields/checkbox-field/checkbox-field.component";
import { RichTextField } from "../../../../../../features/forms/fields/rich-text-field/components/rich-text-field/rich-text-field.component";

import { CbTemplateControlProps } from "../../../../types/cb-template-control-props/cb-template-control.props";

export const CbTemplateControlVendorAssetsReq = (props: CbTemplateControlProps) => (
  <BorderedBlock>
    <CheckboxField
      form={props.form}
      label="Are Vendor Assets Provided"
      name="areVendorAssetsProvided"
      userPermissions={props.userPermissions}
    >
      <RichTextField
        form={props.form}
        label="Location of Vendor Provided Assets"
        name="vendorAssetsLocation"
        userPermissions={props.userPermissions}
      />
    </CheckboxField>
  </BorderedBlock>
);
